import React, { useContext, useEffect,useState } from "react";
import { TextField, Checkbox } from "@fluentui/react";
import "../Styles/EditPatientCss.css";
import "../../../../index.css";
import { CopyIcon } from "@fluentui/react-icons-mdl2";
import { t } from "i18next";
import themeContext from "../../../../context/theme/ThemeContext";
import { USERTYPES } from "../../../../constants/Constants";
import userContext from "../../../../context/users/UserContext";
import MobileInput from "../../../../components/MobileInput";
import { getEnv } from '../../../../helpers/EnvHelper';

const SendReportBody = (props) => {
  const { themeName,getAlterClass } = useContext(themeContext);
  const [emailFieldEnable, setEmailFieldEnable] = useState(false);
  const showOnlyEmailField = props.showOnlyEmailField;
  const {
      // sections (handlers already auto-check both sub-channels)
      reportLinkChecked, setReportLinkChecked,
      attachmentChecked,  setAttachmentChecked,

      // Share Link sub-channels
      reportLink, reportLinkEmail, setReportLinkEmail,
      linkEmailChecked, setLinkEmailChecked,
      linkWhatsappChecked, linkWhatsappNumber,
      setLinkWhatsappChecked, setLinkWhatsappNumber,

      // Attachment sub-channels
      attachmentEmail, setAttachmentEmail,
      attachmentEmailChecked, setAttachmentEmailChecked,
      attachWhatsappChecked, attachWhatsappNumber,
      setAttachWhatsappChecked, setAttachWhatsappNumber,
      
      errors
  } = props;
  const {roles} = useContext(userContext);
  let isEnableWhatsApp =   (getEnv("REACT_APP_ENABLE_WHATSAPP") == "true" || getEnv("REACT_APP_ENABLE_WHATSAPP") == true) ? true : false;
  const handleCopyUrl = () => {
    let hiddenMessage = document.getElementById("copied-msg");
    let copyText = document.getElementById("report_url");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
    hiddenMessage.style.display = "block";
    setTimeout(()=>{
      hiddenMessage.style.display = "none";
    },5000);
  };

  const checkBoxStyle = {
    text: {
      // color: "white",
      fontWeight: "bold",
    },
    checkbox: {
      // borderColor: "#ffffffa6",
    },
  };

  const emailCheckBoxStyle = {
    
    root:{
      margin:'0px',
      minWidth: '110px',
      label:{
        display:'flex',
        alignItems:"center",
        //marginRight:'10px'
      },
    },
    text: {
      // color: "white",
      fontWeight: "bold",
    },
    checkbox: {
      // borderColor: "#ffffffa6",
    },
  };

  // border: 1px solid rgba(200, 198, 196, 0.3);
  //   background: none transparent;

  const textFieldStyle = {
    fieldGroup: {
      '&.is-disabled': {
        background: 'gray !important',
        border:'1px solid rgba(200, 198, 196, 0.3) !important',
        cursor:'not-allowed',
      },
    },
    root:{
      borderRadius: '7px',
      '&.is-disabled': {
        backgroundColor: 'transparent !important',
        cursor:'not-allowed',
        border:'none !important'
      },
    },
    field: {
          backgroundColor: 'transparent !important',
          border:'1px solid rgba(200, 198, 196, 0.3) !important'
    },
  }
  

  const handleCopy = (e) => {
    e.preventDefault(); // Prevent Ctrl+C
  };
  const validateEmail =(e)=>{
    const value = e.target.value;
                  props.setAttachmentEmail(value);

                  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                  if (!value) {
                    props.setErrors({ ...props.errors, reportEmail: "" });
                  } else if (!emailRegex.test(value)) {
                    props.setErrors({ ...props.errors, reportEmail: "Invalid email" });
                  } else {
                    props.setErrors({ ...props.errors, reportEmail: "" });
                  }
  }
  useEffect(()=>{
    if(props.reportLinkChecked){
      console.log("--- True ----");
      setEmailFieldEnable(true);
    }else{
      console.log("--- False ----");
      setEmailFieldEnable(false);
    }
  },[props.reportLinkChecked])

  useEffect(() => {
    // keep the link email sub-checkbox in sync with section
    if (!reportLinkChecked) setLinkEmailChecked(false);
    if (!attachmentChecked) setAttachmentEmailChecked(false);
    // if WhatsApp is turned off anywhere, the field stays but disabled via conditions below
  }, [reportLinkChecked, attachmentChecked]);

  return (
    showOnlyEmailField ?<>
        <div style={{ padding: "30px 25px 30px 28px" }}>
        <div
            className="ms-Grid-row"
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div className="study-list-send-report-label-container">
              <label className="study-list-send-report-label-text" htmlFor="">Email </label>
            </div>
            <TextField
              className="form-field ms-sm12 ms-md8 ms-lg4 ms-xl12 border-adding"
              name="attachmentEmail "
              styles={textFieldStyle}
              value={props.attachmentEmail}
              onChange={(e) => validateEmail(e)}
              errorMessage={props.errors.reportEmail}
            />
          </div>

        </div>
    </> :
    <> 
      <div className="send-report-body" style={{ padding: "20px 25px 20px 16px" }}>
        {/* top,  shareReportLink div */}
        <div className="">
          <Checkbox
            shape="circular"
            styles={checkBoxStyle}
            label={t("label.share-link")}
            onChange={(e,data) => {
              console.log("--- Flag ---",data);
              if(!data){
                // props.setReportLink("");
                let hiddenMessage = document.getElementById("copied-msg");
                hiddenMessage.style.display = "none";
                props.setReportLinkEmail("");
              }
              props.setReportLinkChecked(!props.reportLinkChecked);
            }}
          />
          <div>
            <div
              className="ms-Grid-row"
              style={{
                display: "flex",
                flexDirection: "row",
                marginLeft: "50px",
              }}
            >
              <div className="study-list-send-report-label-container">
                <label className="study-list-send-report-label-text" htmlFor="">{t("label.url").toUpperCase()} </label>
              </div>

              <TextField
                className="form-field ms-sm12 ms-md8 ms-lg4 ms-xl12 border-adding"
                name="reportUrl"
                styles={textFieldStyle}
                id="report_url"
                onCopy={handleCopy}
                value={props.reportLink}
                disabled={!props.reportLinkChecked}
              />
              <div style={{display:'flex',alignItems:'center',justifyContent:'center',marginLeft:'5px'}}>
              <CopyIcon
                id="copied_msg"
                onClick={()=>{if(props.reportLinkChecked){handleCopyUrl()}}}
                style={{ cursor: !props.reportLinkChecked?'not-allowed':'pointer',color:!props.reportLinkChecked?'gray':themeName === "light"?"black":"white", marginLeft: "5px",fontSize:'20px' }}
                disabled={!props.reportLinkChecked}
              />
              </div>
              
            </div>
            <p className={getAlterClass(themeName,"study-list-copied-msg")} id="copied-msg">
              {t("share-study.link-copied-successfully")}
            </p>
             {(props.emailEnabled || (roles[0] == USERTYPES.ADMIN ))&& (
            <div
              className="ms-Grid-row"
              style={{
                display: "flex",
                flexDirection: "row",
                marginLeft: "11px",
                marginTop: "20px",
              }}
            >
              <Checkbox 
              // onChange={(e,data) => {
              //   console.log("--- Flag ---",data);
              //   if(!data){
              //     props.setReportLinkEmail("");
              //   }
              //   setEmailFieldEnable(data)
              // }}
              styles={emailCheckBoxStyle} 
              shape="circular" 
              //checked={emailFieldEnable}
              label={t("user.email")} 
              checked={linkEmailChecked}
              disabled={!reportLinkChecked} 
              onChange={(_, v) => { 
                if (!v) setReportLinkEmail(""); 
                setLinkEmailChecked(!!v); 
              }}
              />
              
              <TextField
                className="form-field ms-sm12 ms-md8 ms-lg4 ms-xl12 border-adding"
                styles={textFieldStyle}
                name="reportEmail"
                value={props.reportLinkEmail}
                //disabled={!props.reportLinkChecked || !emailFieldEnable}
                disabled={!reportLinkChecked || !linkEmailChecked}
                onChange={(e) => {
                  props.setReportLinkEmail(e.target.value);
                }}
                errorMessage={(reportLinkChecked && linkEmailChecked) ? props.errors.reportEmail : undefined}
              />
            </div>
             )}
             {/* Sub-channel: WhatsApp for Share Link (number editable but disabled unless both toggles are on) */}
             {(props.whatsappEnabled || (roles[0] == USERTYPES.ADMIN ))&& isEnableWhatsApp && (
              <div className="ms-Grid-row" style={{ display:"flex", flexDirection:"row", marginLeft: 11, marginTop: 10 }}>
                <Checkbox
                  styles={emailCheckBoxStyle}
                  shape="circular"
                  label={t("label.send-whatsapp")}
                  checked={linkWhatsappChecked}
                  disabled={!reportLinkChecked}
                  //onChange={(_, v) => setLinkWhatsappChecked(!!v)}
                  onChange={(_, v) => {
                    setLinkWhatsappChecked(!!v);
                    // clear WhatsApp error immediately when toggling
                    props.setErrors && props.setErrors(prev => { const c = {...prev}; delete c.linkWhatsappNumber; return c; });
                    // if unchecking, also clear the input
                    if (!v) props.setLinkWhatsappNumber && props.setLinkWhatsappNumber("");
                  }}
                />
                {/* <TextField
                  className="form-field ms-sm12 ms-md8 ms-lg4 ms-xl12 border-adding"
                  name="whatsappNumber"
                  styles={textFieldStyle}
                  value={linkWhatsappNumber}
                  disabled={!reportLinkChecked || !linkWhatsappChecked}
                  onChange={(e) => setLinkWhatsappNumber(e.target.value)}
                  errorMessage={errors.whatsappNumber}
                /> */}
                <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                 {(  linkWhatsappChecked) ? (
                <MobileInput
                  name="whatsappNumber"
                  value={linkWhatsappNumber || ""}
                  onBlurCustom={() =>
                    props.handleBlur && props.handleBlur({ target: { name: "whatsappNumber" } })
                  }
                  onChangeCustom={(value) => {
                    if (!reportLinkChecked || !linkWhatsappChecked) return;
                    if (value && !value.startsWith("+")) value = "+" + value;
                    setLinkWhatsappNumber && setLinkWhatsappNumber(value);
                      props.setErrors && props.setErrors(prev => { const c = {...prev}; delete c.linkWhatsappNumber; return c; });
                  }}
                  touched={props.touched && props.touched.whatsappNumber}
                  //errorMessage={props.touched && props.touched.whatsappNumber ? errors.whatsappNumber : undefined}
                  errorMessage={(reportLinkChecked && linkWhatsappChecked) ? props.errors?.linkWhatsappNumber : undefined}
                  disabled={!reportLinkChecked || !linkWhatsappChecked}                  
                  //inputStyle={{ width: "100%" }}
                />
              ) : (
                <TextField
                  className="form-field ms-sm12 ms-md8 ms-lg4 ms-xl12 border-adding"
                  name="whatsappNumber"
                  styles={textFieldStyle}
                  value={linkWhatsappNumber}
                  disabled={true}
                  onChange={() => {}}
                  placeholder={t("share-study.placeholder.whatsapp")}
                />
              )}
              {reportLinkChecked && linkWhatsappChecked && props.errors?.linkWhatsappNumber && (
                <div style={{ color: "red", marginTop: 6, fontSize: 12, fontWeight: 700 }}>
                  {props.errors.linkWhatsappNumber}
                </div>
              )}
              </div>
              </div>
             )}
            </div>
          </div>

          {/* buttom send Attachment div */}
          <div className="" style={{ marginTop: "15px" }}>
            <Checkbox
              styles={checkBoxStyle}
              shape="circular"
              label={t("label.send-attachment")}
              // onChange={(e,data) => {
              //   props.setAttachmentChecked(data);
              // }}
              checked={attachmentChecked}
              onChange={(_, v) => {
                if (!v) { setAttachmentEmail(""); setAttachmentEmailChecked(false); setAttachWhatsappChecked(false); setAttachWhatsappNumber(""); }
                setAttachmentChecked(!!v);   // container handler auto-checks both by default
              }}
            />
             {(props.emailEnabled || (roles[0] == USERTYPES.ADMIN ))&& (
          <div
            className="ms-Grid-row"
            style={{
              display: "flex",
              flexDirection: "row",
              marginLeft: "11px",
              marginTop: "10px"
            }}
          >
            <Checkbox
            styles={emailCheckBoxStyle}
            shape="circular"
            label={t("user.email")}
            checked={attachmentEmailChecked}
            disabled={!attachmentChecked}
            onChange={(_, v) => {
              if (!v) setAttachmentEmail("");
              setAttachmentEmailChecked(!!v);
            }}
          />
            {/* <div className="study-list-send-report-label-container">
              <label className="study-list-send-report-label-text" htmlFor="">{t("user.email")} </label>
            </div> */}
            <TextField
              className="form-field ms-sm12 ms-md8 ms-lg4 ms-xl12 border-adding"
              name="attachmentEmail "
              styles={textFieldStyle}
              value={props.attachmentEmail}
              disabled={!props.attachmentChecked || !attachmentEmailChecked}
              onChange={(e) => props.setAttachmentEmail(e.target.value)}
              errorMessage={props.errors.attachmentEmail}
            />
          </div>
             )}
          {(props.whatsappEnabled || (roles[0] == USERTYPES.ADMIN ) ) && isEnableWhatsApp && (
            <div className="ms-Grid-row" style={{ display:"flex", flexDirection:"row", marginLeft: 11, marginTop: 10 }}>
            <Checkbox
              styles={emailCheckBoxStyle}
              shape="circular"
              label={t("label.send-whatsapp")}
              checked={attachWhatsappChecked}
              //disabled={!attachWhatsappChecked}
              disabled={!attachmentChecked}
              //onChange={(_, v) => setAttachWhatsappChecked(!!v)}
              onChange={(_, v) => {
                setAttachWhatsappChecked(!!v);
                props.setErrors && props.setErrors(prev => { const c = {...prev}; delete c.attachWhatsappNumber; return c; });
                if (!v) props.setAttachWhatsappNumber && props.setAttachWhatsappNumber("");
              }}
            />
            {/* <TextField
              className="form-field ms-sm12 ms-md8 ms-lg4 ms-xl12 border-adding"
              name="whatsappNumber"
              styles={textFieldStyle}
              value={attachWhatsappNumber}
              disabled={!attachmentChecked || !attachWhatsappChecked}
              onChange={(e) => setAttachWhatsappChecked(e.target.value)}
              errorMessage={errors.whatsappNumber}
            /> */}
            <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
             {( attachWhatsappChecked) ? (
              <MobileInput
                name="whatsappNumberAttachment"
                value={attachWhatsappNumber || ""}
                onBlurCustom={() =>
                  props.handleBlur && props.handleBlur({ target: { name: "whatsappNumberAttachment" } })
                }
                onChangeCustom={(value) => {
                  if (!attachmentChecked || !attachWhatsappChecked) return;
                  if (value && !value.startsWith("+")) value = "+" + value;
                  setAttachWhatsappNumber && setAttachWhatsappNumber(value);
                    props.setErrors && props.setErrors(prev => { const c = {...prev}; delete c.attachWhatsappNumber; return c; });
                }}
                touched={props.touched && props.touched.whatsappNumber}
                errorMessage={props.touched && props.touched.whatsappNumber ? props.errors?.attachWhatsappNumber : "undefined"}
                disabled={false}
                inputStyle={{ width: "100%" }}
              />
            ) : (
              <TextField
                className="form-field ms-sm12 ms-md8 ms-lg4 ms-xl12 border-adding"
                name="whatsappNumber"
                styles={textFieldStyle}
                value={attachWhatsappNumber}
                disabled={true}
                onChange={() => {}}
                placeholder={t("share-study.placeholder.whatsapp")}
                errorMessage={errors.whatsappNumber}
              />
            )}
            {attachmentChecked && attachWhatsappChecked && props.errors?.attachWhatsappNumber && (
              <div style={{ color: "red", marginTop: 6, fontSize: 12, fontWeight: 700 }}>
                {props.errors.attachWhatsappNumber}
              </div>
            )}
            </div>
          </div>
          )}
        </div>

      </div>
    </>
  );
};

export default SendReportBody;
